// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6ff1cb16","239":"89f0b867","453":"2b4eba9d","455":"0a08efbf"}[chunkId] + ".chunk.js";
};